import React from 'react';

import {ASSAY_SCHEMA_SIDEBAR_SECTIONS, ASSAY_TYPES} from 'results/assay-schemas/AssaySchemaConstants';
import * as AssaySchemaDAO from 'results/assay-schemas/AssaySchemaDAO';
import {MODEL_NAMES, RESULT_PRODUCT_SCHEMAS} from 'results/ResultsNamingConstants';

import EmptySidebarIcon from './EmptySidebarIcon';
import * as SidebarConstants from './SidebarConstants';
import SidebarItem from './SidebarItem';

interface ResultSchemaSettingsProps {
  section: SidebarConstants.Section;
}

export default function ResultSchemaSettings(props: ResultSchemaSettingsProps): JSX.Element {
  return (
    <div>
      <div className="browser-nav-header">{RESULT_PRODUCT_SCHEMAS}</div>
      <SidebarItem
        active={props.section === ASSAY_SCHEMA_SIDEBAR_SECTIONS[ASSAY_TYPES.ASSAY_RESULT]}
        icon={<EmptySidebarIcon />}
        name={`${MODEL_NAMES.Result} schemas`}
        link={AssaySchemaDAO.assaySchemasURL(ASSAY_TYPES.ASSAY_RESULT)}
      />
    </div>
  );
}
